import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ClientDropdownViewComponent } from './components/client-dropdown-view/client-dropdown-view.component';
import { ClientSelectionViewComponent } from './components/client-selection-view/client-selection-view.component';
import { DestinationsDropdownViewComponent } from './components/destinations-dropdown-view/destinations-dropdown-view.component';
import { DynamicDropdownViewComponent } from './components/dynamic-dropdown-view/dynamic-dropdown-view.component';
import { IdentifierDropdownViewComponent } from './components/identifier-dropdown-view/identifier-dropdown-view.component';
import { IntegrationDropdownViewComponent } from './components/integration-dropdown-view/integration-dropdown-view.component';
import { LTDropDownComponent } from './components/lt-dropdown/lt-dropdown.component';
import { ServerDropdownViewComponent } from './components/server-dropdown-view/server-dropdown-view.component';
@NgModule({
  imports: [
    CommonModule,
    ClientDropdownViewComponent,
    ClientSelectionViewComponent,
    DestinationsDropdownViewComponent,
    DynamicDropdownViewComponent,
    IdentifierDropdownViewComponent,
    IntegrationDropdownViewComponent,
    LTDropDownComponent,
    ServerDropdownViewComponent,
  ],
  exports: [
    ClientDropdownViewComponent,
    ClientSelectionViewComponent,
    DestinationsDropdownViewComponent,
    DynamicDropdownViewComponent,
    IdentifierDropdownViewComponent,
    IntegrationDropdownViewComponent,
    LTDropDownComponent,
    ServerDropdownViewComponent,
  ],
})
export class LTDropDownModule { }